import React from 'react';
// @ts-ignore
import computer from '../../../assets/pictures/projects/software/computer.mp4';
// @ts-ignore
import os from '../../../assets/pictures/projects/software/os.mp4';
// @ts-ignore
import boleqroom from '../../../assets/pictures/projects/software/boleqroom.mp4';
import ResumeDownload from '../ResumeDownload';
import VideoAsset from '../../general/VideoAsset';

export interface SoftwareProjectsProps {}

const SoftwareProjects: React.FC<SoftwareProjectsProps> = (props) => {
    return (
        <div className="site-page-content">
            <h1>Software</h1>
            <h3>Projects</h3>
            <br />
            <p>
                Below are some of my favorite software projects I have worked on
                over the last few years.
            </p>
            <br />
            <ResumeDownload />
            <br />
            <div className="text-block">
  <h2><a
                        rel="noreferrer"
                        target="_blank"
                        href="https://boleq.com/"
                    >
                        Boleq's Showcase
                    </a> </h2>
                <br />
                <p>
                    boleq.com is my portfolio website, and also the
                    website you are on right now. This project was an absolute
                    joy to make and challenged me both technically and
                    creatively. Early in 2025, I knew I wanted to make an
                    interactive portfolio to aid my job search. I eventually got
                    the idea for this site around early September and began
                    development early November. If you are reading this, it's
                    pretty much done!
                </p>
                <br />
                <div className="captioned-image">
                    <VideoAsset src={computer} />
                    <p style={styles.caption}>
                        <sub>
                            <b>Figure 1:</b> Blender Scene of the 3D website.
                            The scene from Blender was baked and exported in a
                            GLTF format.
                        </sub>
                    </p>
                </div>
                <p>
                    Now, a quick technical breakdown of the site. The website is
                    split into two parts, the 3D site, and the 2D OS site. The
                    3D site uses Three.js to render the scene and renders the 2D
                    site inside of it using an iframe. The 2D OS site is a
                    simple react site that is hosted{' '}
                    <a
                        rel="noreferrer"
                        target="_blank"
                        href="https://boleq.com/"
                    >
                        here
                    </a>{' '}
                    and works as a standalone web app. The actual rendering of
                    the 2D site is accomplished using a CSS renderer provided by
                    Three.js that transforms the html of the 2D site with 3D CSS
                    transforms to give the illusion of three dimensionality.
                </p>
        <p>
                    I'm skipping over a lot of details in exchange for brevity,
                    but I do plan on doing a more in depth breakdown for those
                    interested sometime in the future. To get updates with that
                    project feel free to follow me on LinkedIN{' '}
                    <a
                        rel="noreferrer"
                        target="_blank"
                        href="https://linkedin.com/in/boleq/"
                    >
                        @boleq
                    </a>
                </p>   
                            <div className="text-block">
                <h2><a
                        rel="noreferrer"
                        target="_blank"
                        href="https://room.boleq.com/"
                    >
                        Boleq's Room
                    </a> </h2>
                <br />
                <br />
                <div className="captioned-image">
                    <VideoAsset src={boleqroom} />
                    <p style={styles.caption}>
                        <sub>
                            <b>Figure 2:</b> 3D scene of my room.
                        </sub>
                    </p>
                </div>                          
                                        <h2><a
                        rel="noreferrer"
                        target="_blank"
                        href="https://os.boleq.com/"
                    >
                        BoleqOS
                    </a> </h2>
                <br />
                <br />
                <div className="captioned-image">
                    <VideoAsset src={os} />
                    <p style={styles.caption}>
                        <sub>
                            <b>Figure 3:</b> Scene of my OS.
                        </sub>
                    </p>
                </div> 
            </div>        
            </div>
        </div>
    );
};

const styles: StyleSheetCSS = {
    video: {
        width: '100%',
        padding: 12,
    },
    caption: {
        width: '80%',
    },
};

export default SoftwareProjects;
